import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'getProperty',
  standalone: true,
  pure: true,
})
export class GetPropertyPipe implements PipeTransform {
  /**
   * Get a property value from an object using a key path.
   * Supports nested access via dot notation or array of keys.
   *
   * @param obj - The object to get the property from
   * @param keyPath - The key or dot-separated path (e.g., 'slug', 'user.name', 'status.added')
   * @param defaultValue - Value to return if property doesn't exist (default: undefined)
   *
   * @example
   * // Simple key access
   * {{ constraint | getProperty:'slug' }}
   *
   * @example
   * // Nested access using dot notation
   * {{ libraryStatus | getProperty:constraint.slug + '.added' }}
   *
   * @example
   * // With default value
   * {{ obj | getProperty:'missing.key':false }}
   */
  transform<T = any>(obj: any, keyPath: string, defaultValue?: T): T | undefined {
    if (obj == null || !keyPath) {
      return defaultValue;
    }

    const keys = keyPath.split('.');
    let result: any = obj;

    for (const key of keys) {
      if (result == null || typeof result !== 'object') {
        return defaultValue;
      }
      result = result[key];
    }

    return result ?? defaultValue;
  }
}
